import useSiteConfiguration from '@frontend/libs/hooks/useSiteConfiguration'
import placeholder from '@images/placeholder-wide.jpg'
import { Image } from '@nextui-org/react'
import { Link } from 'react-router-dom'

function GroupMegaMenu() {
  const { settings } = useSiteConfiguration()
  const group = settings?.megaMenus.group

  if (!group) {
    return <></>
  }

  return (
    <div className="mx-auto max-w-screen-lg md:px-7 md:py-6">
      <div className="grid grid-cols-2 gap-4 md:grid-cols-3 md:gap-6">
        {group.map((item, index) => (
          <div key={index}>
            <Link
              className="block"
              target={item.link.target}
              title={item.link.title}
              to={item.link.url}
            >
              <Image
                alt={item.image.alt}
                className="aspect-[3/4] h-full w-full object-cover"
                classNames={{
                  img: 'opacity-100',
                }}
                disableSkeleton
                fallbackSrc={placeholder}
                isLoading={false}
                loading="eager"
                src={item.image.sizes.large}
                srcSet={item.image.srcset}
              />
              <p className="m-0 mt-3 font-medium uppercase text-primary">
                {item.title}
              </p>
            </Link>
          </div>
        ))}
      </div>
    </div>
  )
}

export default GroupMegaMenu
